import { AxiosInstance } from 'axios';
import * as InHouseReportService from './services';

export type InHouseReportServiceType = ReturnType<typeof InHouseReportService.exportPDF>;

export const initInHouseReportService = (axios: AxiosInstance): InHouseReportServiceType =>
  InHouseReportService.exportPDF(axios);
